(function () {
  function getTermsContainer(element) {
    return (
      element.closest('.cart_notification_links_inner') ||
      element.closest('#main-cart-footer') ||
      element.closest('.cart_subtotal') ||
      document
    );
  }

  function showTermsError(container) {
    const checkbox = container.querySelector('[data-rg-cart-terms]');
    const error = container.querySelector('[data-rg-cart-terms-error]');
    const label = container.querySelector('.rg-cart-terms');

    if (error) error.hidden = false;
    if (label) label.classList.add('has-error');

    if (checkbox) {
      checkbox.focus({ preventScroll: true });
    }
  }

  function hideTermsError(container) {
    const error = container.querySelector('[data-rg-cart-terms-error]');
    const label = container.querySelector('.rg-cart-terms');

    if (error) error.hidden = true;
    if (label) label.classList.remove('has-error');
  }

  document.addEventListener(
    'click',
    function (event) {
      const checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"], .cart__checkout-button'
      );

      if (!checkoutButton) return;

      const container = getTermsContainer(checkoutButton);
      const checkbox = container.querySelector('[data-rg-cart-terms]');

      if (!checkbox) return;

      if (checkbox.checked) {
        hideTermsError(container);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      showTermsError(container);
    },
    true
  );

  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('[data-rg-cart-terms]');

    if (!checkbox) return;

    const container = getTermsContainer(checkbox);

    if (checkbox.checked) {
      hideTermsError(container);
    }
  });
})();